import { Account, Feature, getFeatureFromPlan, PlanInterval } from '../../../models';
import {
  BOOLEAN_QUERY_PARAMS,
  PLAN_BILLING_QUERY_PARAM,
  PLAN_FEATURE_QUERY_PARAM,
  PLAN_QUANTITY_QUERY_PARAM,
  PRODUCT_QUERY_PARAMS,
  TRACKING_QUERY_PARAMS,
} from '../../../utils/Constants';
import { useQuery } from '../../../routes';

type QueryParam = {
  [key: string]: any; // 👈️ variable key
};

export const useParseQueryParam = (selectedAccount?: Account): QueryParam => {
  const { get } = useQuery();
  const spEnabled = get('spEnabled') === 'true';
  const queryParam: QueryParam = {};

  if (spEnabled) {
    queryParam.sp = true;
  }

  BOOLEAN_QUERY_PARAMS.forEach(param => {
    const prams = get(param) === 'true';
    if (prams) {
      queryParam[param] = true;
    }
  });

  PRODUCT_QUERY_PARAMS.forEach(param => {
    const value = get(param);
    if (value) {
      const feature = getFeatureFromPlan(param);
      const prefix = Feature.getFeaturePrefix(feature);
      const interval = PlanInterval.getIntervalFromPlanCode(param);
      queryParam[`${prefix}Quota`] = value;
      queryParam[`${prefix}Cycle`] = interval;
    }
  });
  TRACKING_QUERY_PARAMS.forEach(param => {
    const value = get(param);
    if (value) {
      queryParam[param] = value;
    }
  });

  const planFeature = Feature.fromString(
    get(PLAN_FEATURE_QUERY_PARAM)?.trim().toUpperCase() ?? '',
  );
  const hasCanonicalPlanParams = !!planFeature
    && (
      get(`${Feature.getFeaturePrefix(planFeature)}Quota`) !== null
      || get(`${Feature.getFeaturePrefix(planFeature)}Cycle`) !== null
    );

  if (!hasCanonicalPlanParams) {
    [
      PLAN_FEATURE_QUERY_PARAM,
      PLAN_QUANTITY_QUERY_PARAM,
      PLAN_BILLING_QUERY_PARAM,
    ].forEach(param => {
      const value = get(param);
      if (value) {
        queryParam[param] = value;
      }
    });
  }

  if (selectedAccount) {
    queryParam.accountId = selectedAccount.id;
  }
  return queryParam;
};
